import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import { Sparkles, Loader2 } from "lucide-react";
import api from "../../lib/api";

export default function MarketNarrative({ property }) {
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(true);
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    let active = true;
    (async () => {
      setLoading(true); setFailed(false);
      try {
        const { data } = await api.post("/property/narrative", { property });
        if (!active) return;
        if (data.ok && data.narrative) setText(data.narrative);
        else setFailed(true);
      } catch { if (active) setFailed(true); }
      finally { if (active) setLoading(false); }
    })();
    return () => { active = false; };
  }, [property]);

  if (failed) return null;

  return (
    <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}
      className="rounded-2xl border border-brand-hairline bg-white p-6 sm:p-8 shadow-[0_4px_20px_rgba(27,59,43,0.04)]"
      data-testid="market-narrative-card">
      <div className="flex items-center gap-2">
        <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-brand-emeraldLight">
          <Sparkles className="h-4 w-4 text-brand-emerald" />
        </span>
        <span className="eyebrow">Market Insight</span>
      </div>
      {loading ? (
        <div className="mt-5 flex items-center gap-3 text-brand-stone" data-testid="narrative-loading">
          <Loader2 className="h-4 w-4 animate-spin text-brand-emerald" />
          <span className="text-sm">Analyzing comparable sales…</span>
        </div>
      ) : (
        <div className="mt-4 space-y-3 text-brand-ink leading-relaxed text-sm sm:text-base" data-testid="narrative-text">
          {text.split(/\n+/).filter(Boolean).map((p, i) => <p key={i}>{p}</p>)}
        </div>
      )}
      <p className="mt-5 text-[0.7rem] uppercase tracking-wider text-brand-stone/70">
        AI-generated from Equitas comparable data · Not an appraisal
      </p>
    </motion.div>
  );
}
